module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// ./~/readable-stream/transform.js
// module id = 1760
// module chunks = 1